export enum ProductSeries {
    PatriotMark = "PATRIOTMARK SERIES",
    OptiMark = "OPTIMARK SERIES",
    BenchmarkFlex = "BENCHMARK FLEX SERIES"
}
